module.exports = __webpack_public_path__ + "static/img/INDHI-KIRK.b54c55a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/INDHI-KIRK.jpg
// module id = tgWh
// module chunks = 0